import { render, staticRenderFns } from "./kecelakaanKerja.vue?vue&type=template&id=58057be8"
import script from "./kecelakaanKerja.vue?vue&type=script&lang=js"
export * from "./kecelakaanKerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports